<template>
  <div class="ar-page" :class="device.desktop ? 'pa-6' : 'pa-0'">
    <v-row>
      <v-col cols="12">
        <v-card class="ar-card animated animate__bounceIn elevation-0">
          <div class="ar-toolbar">
            <div class="ar-toolbar__left">
              <div class="ar-toolbar__icon">
                <v-icon>mdi-reply-all-outline</v-icon>
              </div>
              <div>
                <div class="ar-toolbar__title">Auto Reply</div>
                <div class="ar-toolbar__sub">
                  {{ records.length || 0 }} aturan balasan otomatis
                </div>
              </div>
            </div>

            <div class="ar-toolbar__actions">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                placeholder="Cari keyword / nomor..."
                single-line
                hide-details
                dense
                outlined
                color="#1f7a57"
                class="ar-search"
                clearable
              ></v-text-field>

              <v-tooltip bottom color="#0d4a36">
                <template v-slot:activator="{ on }">
                  <v-btn
                    icon
                    class="ar-icon-btn"
                    v-on="on"
                    v-show="page.actions.refresh"
                    @click="fetchRecords"
                  >
                    <v-icon>mdi-refresh</v-icon>
                  </v-btn>
                </template>
                <span>Muat ulang</span>
              </v-tooltip>

              <v-btn
                class="ar-btn-primary"
                v-show="page.actions.add"
                @click="openForm"
              >
                <v-icon left small>mdi-plus</v-icon>
                Tambah Aturan
              </v-btn>
            </div>
          </div>

          <v-data-table
            v-show="device.desktop"
            :headers="headers"
            :items="records"
            :items-per-page="table.options.itemsPerPage"
            :page.sync="table.options.page"
            class="ar-table"
            :loading="loading.table"
            loading-text="Memuat auto reply..."
            :search="search"
            hide-default-footer
            @page-count="table.options.pageCount = $event"
          >
            <v-progress-linear
              slot="progress"
              color="#1f7a57"
              height="2"
              indeterminate
            ></v-progress-linear>

            <template v-slot:item.phone_number="{ value }">
              <span class="ar-phone">{{ value || '—' }}</span>
            </template>

            <template v-slot:item.keyword="{ item }">
              <div>
                <span class="ar-keyword">{{ item.keyword }}</span>
                <div class="ar-match">{{ item.match_type_label }}</div>
              </div>
            </template>

            <template v-slot:item.reply_text="{ value }">
              <div class="ar-reply" :title="value">{{ value || '—' }}</div>
            </template>

            <template v-slot:item.status="{ value }">
              <span
                class="ar-status"
                :class="isActive(value) ? 'is-online' : 'is-idle'"
              >
                <span class="ar-status__dot"></span>
                {{ isActive(value) ? 'Aktif' : 'Nonaktif' }}
              </span>
            </template>

            <template v-slot:item.id="{ value }">
              <div class="ar-row-actions">
                <v-tooltip bottom color="#0d4a36">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      icon
                      small
                      class="ar-action-edit"
                      v-on="on"
                      v-show="page.actions.edit"
                      @click="editRecord(value)"
                    >
                      <v-icon small>mdi-pencil</v-icon>
                    </v-btn>
                  </template>
                  <span>Ubah</span>
                </v-tooltip>
                <v-tooltip bottom color="#0d4a36">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      icon
                      small
                      class="ar-action-delete"
                      v-on="on"
                      v-show="page.actions.delete"
                      @click="postDeleteRecord(value)"
                    >
                      <v-icon small>mdi-delete-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>Hapus</span>
                </v-tooltip>
              </div>
            </template>

            <template v-slot:no-data>
              <div class="ar-empty">
                <v-icon large color="#8fd6b5">mdi-reply-all-outline</v-icon>
                <div class="ar-empty__title">Belum ada aturan auto reply</div>
                <div class="ar-empty__sub">
                  Buat balasan otomatis berdasarkan keyword untuk nomor WhatsApp terpilih
                </div>
                <v-btn
                  class="ar-btn-primary mt-4"
                  small
                  v-show="page.actions.add"
                  @click="openForm"
                >
                  <v-icon left small>mdi-plus</v-icon>
                  Tambah Aturan
                </v-btn>
              </div>
            </template>
          </v-data-table>

          <div class="ar-mobile" v-show="device.mobile">
            <div
              v-for="item in filterItems"
              :key="item.id"
              class="ar-mobile-card"
            >
              <div class="ar-mobile-card__top">
                <div>
                  <div class="ar-mobile-card__title">
                    {{ item.name || 'Auto Reply' }}
                  </div>
                  <div class="ar-phone mt-1">{{ item.phone_number }}</div>
                </div>
                <v-menu bottom left origin="center center" transition="scale-transition">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon small v-bind="attrs" v-on="on" class="ar-menu-btn">
                      <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                  </template>
                  <v-list dense class="ar-menu">
                    <v-list-item
                      @click="editRecord(item.id)"
                      v-show="page.actions.edit"
                    >
                      <v-list-item-icon class="mr-2">
                        <v-icon small color="#1f7a57">mdi-pencil</v-icon>
                      </v-list-item-icon>
                      <v-list-item-title>Ubah Data</v-list-item-title>
                    </v-list-item>
                    <v-list-item
                      @click="postDeleteRecord(item.id)"
                      v-show="page.actions.delete"
                    >
                      <v-list-item-icon class="mr-2">
                        <v-icon small color="#c62828">mdi-delete-outline</v-icon>
                      </v-list-item-icon>
                      <v-list-item-title>Hapus Data</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </div>
              <div class="ar-mobile-card__body">
                <div class="ar-keyword">{{ item.keyword }} · {{ item.match_type_label }}</div>
                <div class="ar-reply mt-2">{{ item.reply_text }}</div>
              </div>
              <div class="ar-mobile-card__meta">
                <span
                  class="ar-status"
                  :class="isActive(item.status) ? 'is-online' : 'is-idle'"
                >
                  <span class="ar-status__dot"></span>
                  {{ isActive(item.status) ? 'Aktif' : 'Nonaktif' }}
                </span>
                <span class="ar-priority">Prioritas {{ item.priority || 0 }}</span>
              </div>
            </div>

            <div v-if="!filterItems.length" class="ar-empty pa-8">
              <v-icon large color="#8fd6b5">mdi-reply-all-outline</v-icon>
              <div class="ar-empty__title">Belum ada aturan</div>
            </div>
          </div>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog
      transition="dialog-bottom-transition"
      v-model="form.add"
      :max-width="device.desktop ? '560px' : '100%'"
      persistent
      :fullscreen="device.mobile"
      content-class="ar-dialog"
    >
      <v-card class="ar-dialog-card">
        <div class="ar-dialog-header">
          <div class="ar-dialog-header__copy">
            <v-icon class="mr-2">mdi-reply-all-outline</v-icon>
            {{ form.edit ? 'Ubah Auto Reply' : 'Tambah Auto Reply' }}
          </div>
          <v-btn icon dark small @click="closeForm">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>

        <v-card-text class="ar-dialog-body">
          <div class="ar-field-label">Nama Aturan (opsional)</div>
          <v-text-field
            outlined
            color="#1f7a57"
            hide-details="auto"
            placeholder="Contoh: Sapaan / Info Harga"
            v-model="record.name"
            dense
            class="ar-field mb-4"
            prepend-inner-icon="mdi-tag-outline"
          ></v-text-field>

          <div class="ar-field-label">Nomor WhatsApp</div>
          <v-select
            outlined
            dense
            hide-details="auto"
            color="#1f7a57"
            item-color="#1f7a57"
            v-model="record.phone_number"
            :items="senders"
            class="ar-field mb-4"
            prepend-inner-icon="mdi-whatsapp"
            placeholder="Pilih nomor terdaftar"
          ></v-select>

          <div class="ar-field-label">Tipe Pencocokan</div>
          <v-select
            outlined
            dense
            hide-details="auto"
            color="#1f7a57"
            item-color="#1f7a57"
            v-model="record.match_type"
            :items="matchTypes"
            class="ar-field mb-4"
            prepend-inner-icon="mdi-text-search"
          ></v-select>

          <div class="ar-field-label" v-if="record.match_type !== 'all'">
            Keyword
          </div>
          <v-text-field
            v-if="record.match_type !== 'all'"
            outlined
            color="#1f7a57"
            hide-details="auto"
            placeholder="Contoh: harga / info / halo (boleh banyak, pisah / atau ,)"
            v-model="record.keyword"
            dense
            class="ar-field mb-4"
            prepend-inner-icon="mdi-key-variant"
          ></v-text-field>

          <div class="ar-field-label">Pesan Balasan</div>
          <v-textarea
            outlined
            color="#1f7a57"
            hide-details="auto"
            placeholder="Tulis pesan yang akan dikirim otomatis..."
            v-model="record.reply_text"
            rows="4"
            auto-grow
            dense
            class="ar-field mb-4"
            prepend-inner-icon="mdi-message-reply-text"
          ></v-textarea>

          <div class="ar-field-label">Prioritas</div>
          <v-text-field
            outlined
            color="#1f7a57"
            hide-details="auto"
            type="number"
            placeholder="0"
            v-model.number="record.priority"
            dense
            class="ar-field mb-4"
            prepend-inner-icon="mdi-sort-numeric-variant"
            hint="Angka lebih tinggi dicek lebih dulu"
            persistent-hint
          ></v-text-field>

          <div class="ar-switch-box">
            <div>
              <div class="ar-switch-box__title">Status Aktif</div>
              <div class="ar-switch-box__sub">
                Nonaktifkan tanpa menghapus aturan
              </div>
            </div>
            <v-switch
              v-model="record.status"
              color="#1f7a57"
              hide-details
              dense
              class="mt-0 pt-0"
            ></v-switch>
          </div>
        </v-card-text>

        <v-divider class="ar-divider"></v-divider>
        <v-card-actions class="ar-dialog-actions">
          <v-btn text class="ar-btn-ghost" @click="closeForm">Batal</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            class="ar-btn-primary"
            v-show="!form.edit"
            @click="postAddNewRecord"
          >
            <v-icon left small>mdi-plus</v-icon>
            Tambah
          </v-btn>
          <v-btn
            class="ar-btn-primary"
            v-show="form.edit"
            @click="postUpdateRecord"
          >
            <v-icon left small>mdi-content-save</v-icon>
            Simpan
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import "animate.css";

export default {
  name: "master-data-auto-reply",
  data: () => ({
    headers: [
      {
        text: "Nama",
        align: "start",
        sortable: true,
        value: "name",
        width: 140,
      },
      {
        text: "Nomor WA",
        value: "phone_number",
        sortable: true,
        width: 140,
      },
      {
        text: "Keyword",
        value: "keyword",
        sortable: false,
        width: 150,
      },
      { text: "Balasan", value: "reply_text", sortable: false },
      {
        text: "Prioritas",
        value: "priority",
        sortable: true,
        width: 100,
        align: "center",
      },
      {
        text: "Status",
        align: "start",
        sortable: false,
        value: "status",
        width: 130,
      },
      {
        text: "Aksi",
        value: "id",
        width: 110,
        sortable: false,
        align: "center",
      },
    ],
    search: null,
    senders: [],
    matchTypes: [
      { text: "Mengandung keyword", value: "contains" },
      { text: "Persis sama", value: "exact" },
      { text: "Semua pesan masuk", value: "all" },
    ],
  }),
  computed: {
    ...mapState([
      "page",
      "theme",
      "http",
      "device",
      "record",
      "records",
      "loading",
      "event",
      "snackbar",
      "form",
      "table",
    ]),
    filterItems() {
      if (!this.search) return this.records || [];
      const q = this.search.toLowerCase();
      return (this.records || []).filter((item) => {
        return (
          (item.name || "").toLowerCase().includes(q) ||
          (item.phone_number || "").toLowerCase().includes(q) ||
          (item.keyword || "").toLowerCase().includes(q) ||
          (item.reply_text || "").toLowerCase().includes(q)
        );
      });
    },
  },
  created() {
    this.setPage({
      crud: true,
      dataUrl: "api/master-data/auto-reply",
      pagination: false,
      title: "AUTO REPLY",
      subtitle: "Aturan balasan otomatis untuk nomor WhatsApp terpilih",
      showtable: true,
      breadcrumbs: [
        { text: "Data Master", disabled: true, href: "" },
        { text: "Auto Reply", disabled: false, href: "" },
      ],
      actions: {
        refresh: true,
        add: true,
        edit: true,
        delete: true,
        bulkdelete: false,
        print: false,
        export: false,
        help: false,
      },
    });
    this.fetchRecords();
  },
  mounted() {
    this.fetchSenders();
  },
  methods: {
    ...mapActions([
      "setPage",
      "fetchRecords",
      "postAddNew",
      "postEdit",
      "postUpdate",
      "postConfirmDelete",
      "setRecord",
      "setForm",
    ]),
    isActive(value) {
      if (typeof value === "boolean") return value;
      if (typeof value === "object") {
        const text = (value.text || "").toLowerCase();
        return text.includes("aktif") && !text.includes("tidak");
      }
      return !!value;
    },
    async fetchSenders() {
      try {
        const { data } = await this.http.get("api/combo/pengaturan");
        this.senders = data || [];
      } catch (e) {
        this.senders = [];
      }
    },
    openForm() {
      this.setForm({ add: true, edit: false });
      this.setRecord({
        name: "",
        phone_number: null,
        keyword: "",
        match_type: "contains",
        reply_text: "",
        priority: 0,
        status: true,
      });
    },
    closeForm() {
      this.setForm({ add: false, edit: false });
    },
    validateForm() {
      if (!this.record.phone_number) {
        this.snackbar.color = "orange";
        this.snackbar.text = "Pilih nomor WhatsApp";
        this.snackbar.state = true;
        return false;
      }
      if (
        this.record.match_type !== "all" &&
        !(this.record.keyword || "").trim()
      ) {
        this.snackbar.color = "orange";
        this.snackbar.text = "Isi keyword pencocokan";
        this.snackbar.state = true;
        return false;
      }
      if (!(this.record.reply_text || "").trim()) {
        this.snackbar.color = "orange";
        this.snackbar.text = "Isi pesan balasan";
        this.snackbar.state = true;
        return false;
      }
      return true;
    },
    postAddNewRecord() {
      if (!this.validateForm()) return;
      this.postAddNew(this.record).then(() => {
        this.closeForm();
      });
    },
    editRecord(val) {
      this.postEdit(val);
      this.setForm({ add: true, edit: true });
    },
    postUpdateRecord() {
      if (!this.validateForm()) return;
      this.postUpdate(this.record).then(() => {
        this.closeForm();
      });
    },
    postDeleteRecord(val) {
      this.postConfirmDelete(val);
    },
  },
};
</script>

<style scoped>
.ar-page {
  --gw-ink: #10241c;
  --gw-forest: #0d4a36;
  --gw-leaf: #1f7a57;
  --gw-mint: #8fd6b5;
  --gw-fog: #eef6f1;
  --gw-paper: #f8fbf9;
  --gw-line: #c9ddd3;
  --gw-muted: #5d7268;
}

.ar-card {
  border-radius: 14px !important;
  overflow: hidden;
  border: 1px solid var(--gw-line);
  background: #fff !important;
}

.ar-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  flex-wrap: wrap;
  padding: 1rem 1.15rem;
  background:
    radial-gradient(120% 80% at 0% 0%, #1a6b4d 0%, transparent 55%),
    linear-gradient(175deg, #0b3d2e 0%, #0f5c45 45%, #0a3327 100%);
  color: #f4fbf7;
}

.ar-toolbar__left {
  display: flex;
  align-items: center;
  gap: 0.85rem;
}

.ar-toolbar__icon {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  display: grid;
  place-items: center;
  background: linear-gradient(145deg, #b7ebcf, #8fd6b5);
}

.ar-toolbar__icon .v-icon {
  color: #0b3d2e !important;
}

.ar-toolbar__title {
  font-family: "Outfit", "Montserrat", sans-serif;
  font-weight: 700;
  font-size: 1.05rem;
}

.ar-toolbar__sub {
  margin-top: 0.15rem;
  font-size: 0.75rem;
  color: rgba(244, 251, 247, 0.65);
}

.ar-toolbar__actions {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.ar-search {
  max-width: 260px;
  background: rgba(255, 255, 255, 0.08);
  border-radius: 10px;
}

.ar-search >>> .v-input__slot {
  min-height: 38px !important;
  background: rgba(255, 255, 255, 0.1) !important;
}

.ar-search >>> input,
.ar-search >>> .v-icon {
  color: #f4fbf7 !important;
}

.ar-icon-btn {
  background: rgba(255, 255, 255, 0.1) !important;
  color: #f4fbf7 !important;
}

.ar-btn-primary {
  background: linear-gradient(145deg, #b7ebcf, #8fd6b5) !important;
  color: #0b3d2e !important;
  text-transform: none !important;
  letter-spacing: 0 !important;
  font-weight: 700 !important;
  border-radius: 10px !important;
  box-shadow: none !important;
}

.ar-table {
  background: transparent !important;
}

.ar-table >>> thead th {
  background: var(--gw-fog) !important;
  color: var(--gw-forest) !important;
  font-weight: 700 !important;
  font-size: 0.75rem !important;
  text-transform: uppercase;
  border-bottom: 1px solid var(--gw-line) !important;
}

.ar-table >>> tbody td {
  border-bottom: 1px solid var(--gw-line) !important;
  color: var(--gw-ink);
  height: 68px !important;
}

.ar-phone {
  font-family: "Source Sans 3", sans-serif;
  font-weight: 600;
  color: var(--gw-forest);
}

.ar-keyword {
  font-weight: 700;
  color: var(--gw-ink);
}

.ar-match {
  font-size: 0.72rem;
  color: var(--gw-muted);
  margin-top: 2px;
}

.ar-reply {
  max-width: 280px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: var(--gw-muted);
  font-size: 0.9rem;
}

.ar-status {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.3rem 0.65rem;
  border-radius: 999px;
  font-size: 0.78rem;
  font-weight: 700;
}

.ar-status__dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: currentColor;
}

.ar-status.is-online {
  background: rgba(31, 122, 87, 0.12);
  color: #1f7a57;
}

.ar-status.is-idle {
  background: rgba(93, 114, 104, 0.12);
  color: #5d7268;
}

.ar-row-actions {
  display: flex;
  justify-content: center;
  gap: 0.15rem;
}

.ar-action-edit {
  color: #1f7a57 !important;
}

.ar-action-delete {
  color: #c62828 !important;
}

.ar-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3rem 1rem;
  text-align: center;
}

.ar-empty__title {
  margin-top: 0.75rem;
  font-weight: 700;
  color: var(--gw-ink);
}

.ar-empty__sub {
  margin-top: 0.35rem;
  max-width: 320px;
  color: var(--gw-muted);
  font-size: 0.88rem;
}

.ar-mobile {
  padding: 0.85rem;
  display: grid;
  gap: 0.75rem;
}

.ar-mobile-card {
  border: 1px solid var(--gw-line);
  border-radius: 12px;
  padding: 0.9rem;
  background: var(--gw-paper);
}

.ar-mobile-card__top {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.ar-mobile-card__title {
  font-weight: 700;
  color: var(--gw-ink);
}

.ar-mobile-card__body {
  margin-top: 0.75rem;
  padding: 0.75rem;
  border-radius: 10px;
  background: var(--gw-fog);
}

.ar-mobile-card__meta {
  margin-top: 0.75rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.ar-priority {
  font-size: 0.78rem;
  color: var(--gw-muted);
}

.ar-dialog-card {
  border-radius: 14px !important;
  overflow: hidden;
}

.ar-dialog-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.9rem 1rem;
  background: linear-gradient(175deg, #0b3d2e 0%, #0f5c45 100%);
  color: #f4fbf7;
}

.ar-dialog-header__copy {
  display: flex;
  align-items: center;
  font-weight: 700;
}

.ar-dialog-body {
  padding: 1.15rem 1.15rem 0.5rem !important;
}

.ar-field-label {
  font-size: 0.78rem;
  font-weight: 700;
  color: var(--gw-forest);
  margin-bottom: 0.35rem;
}

.ar-field >>> .v-input__slot {
  border-radius: 10px !important;
}

.ar-switch-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 0.85rem 1rem;
  border-radius: 12px;
  background: var(--gw-fog);
  border: 1px solid var(--gw-line);
  margin-bottom: 0.5rem;
}

.ar-switch-box__title {
  font-weight: 700;
  color: var(--gw-ink);
  font-size: 0.9rem;
}

.ar-switch-box__sub {
  font-size: 0.75rem;
  color: var(--gw-muted);
  margin-top: 0.15rem;
}

.ar-divider {
  border-color: var(--gw-line) !important;
}

.ar-dialog-actions {
  padding: 0.85rem 1rem !important;
}

.ar-btn-ghost {
  text-transform: none !important;
  letter-spacing: 0 !important;
  color: var(--gw-muted) !important;
  font-weight: 600 !important;
}

.ar-menu {
  border-radius: 10px !important;
}

@media (max-width: 600px) {
  .ar-search {
    max-width: 100%;
    width: 100%;
  }
  .ar-toolbar__actions {
    width: 100%;
  }
}
</style>
